export enum Validations {
  REQUIRED = 'required',
  EMAIL = 'email',
  MIN = 'min',
  MAX = 'max',
  PATTERN = 'pattern',
  CUSTOMVALIDATOR = 'customValidator',
  EXCLUDE = 'exclude'
}
